/**
 * React component for rendering an Uber banner.
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.bannerTextData - Data for rendering the banner text.
 * @param {Function} props.setIsUberBannerPresent - Function to set the presence of the Uber banner.
 * @returns {JSX.Element} The rendered UberBanner component.
 */

import Link from "next/link";
import React, { useEffect, useState } from "react";
import styles from "./UberBanner.module.scss";

export default function UberBanner({
  bannerTextData,
  setIsUberBannerPresent = () => { },
  setShowBannerAnimate,
}) {
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const isShowBannerKeyPresent = localStorage.getItem("showUberBanner");
    setShowBanner(isShowBannerKeyPresent !== 'false');
  }, []); 


  console.log("showBanner", showBanner)
  const closeBanner = () => {
    setIsUberBannerPresent(false);
    localStorage.setItem("showUberBanner", "false");
    setShowBannerAnimate(false);
    setShowBanner(false);
  };

  // if (!showBanner) return;`

  return(
    <div className={`relative cursor-pointer min-h-52 md:min-h-36 bg-butter`}>
      <div className="overflow-hidden">
        <div className="flex items-center justify-center py-[6px] xl:px-6">
          {/* <span className="lg:flex-1"></span> */}
          <Link href="/product" className="md:flex-1 text-center w-3/5">
            <span className="small-p md:whitespace-nowrap md:px-0">
              {bannerTextData?.offerBannerText || ""}
            </span>
          </Link>
          <span
            className="flex flex-shrink-0 justify-end absolute right-4 xl:right-0 md:relative"
            onClick={closeBanner}
            title="Close"
          >
            <span className="bg-primary p-2 rounded-full">
              <svg
                className="w-2 h-2"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                ></path>
              </svg>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

